import bellDoodle from './bell-doodle.svg'
import leftPart from './left-part@3x.png'
import personDoodle from './person-doodle.svg'
import sidebarQuickAsystLogo from './QuickAsystWideIcon.png'
import rightChevronIcon from './rightChevronIcon.svg'
import dahsboardIcon from './rounded--outline--dashboard.svg'
import roundedDoneIcon from './rounded--outline--done.svg'
import greyCloseIcon from './sharp--outline--close.svg'
import dropdownIcon from './sharp--outline--dropdown.svg'
import lockResetIcon from './sharp--outline--lock-reset.svg'
import manageAccountIcon from './sharp--outline--manage-accounts.svg'
import notificationIcon from './sharp--outline--notification.svg'
import searchIcon from './sharp--outline--search.svg'
import logoutIcon from './sharp--outline--signout.svg'
import searchTicketIcon from './sharp--outline--ticket1.svg'
import sidebarTicketIcon from './sharp--outline--ticket2.svg'
import sidebarUserIcon from './sharp--outline--users.svg'
import searchUserIcon from './sharp--outline--users1.svg'
import passwordHideIcon from './sharp.svg'
import passwordUnHideIcon from './eyeOnIcon.svg'
import QuickAsystLogo from './QuickAsystLogo.png'
import underConstruction from './under-construction.png'
import bluetick from './BlueTick.svg'
import publishpopup from './Popup Status.svg'
import GreyFilterIcon from './GreyFilterIcon.svg'
import DefaultProfile from './Defaultprofile.png'
import Invoice from './Invoice.svg'
import CloseIcon from "./Close.svg"
import AddIcon from "./AddIcon.svg"
import AffiliateIcon from "./Affiliates.svg"
import ReferalIcon from "./ReferalLink.svg"
import Payout from "./Payout.svg"
import PayoutInprogress from "./PayoutInprogress.svg"
import UserEdit from "./EditAffiliate.svg"
import Deletepopup from "./DeletePopupIcon.svg"
import QuickAsystIcon from "./QuickAsystLogosidebar.svg"
import CopyIcon from "./Copy.svg"
import QuickAsystWideIcon from './QuickAsysticon.svg'
import QuickAsystMailLogo from './QuickAsystMailLogo.png'
import TermsandConditions from "./Terms and Condition.svg"
import AutoPayout from "./AutoPayout.svg"
import errordashboard from "./Error Dashboard.svg"
import barcodeIcon from "./barcode-menu.svg"
import settings from "./Settings icon.svg"
import MLB from "./MLB.png";
import MLS from "./MLS.png";
import NHL from "./NHL.png";
import Football from "./Football.png";
import Basketball from "./Baseketball.png";
import EditListPriceDisable from "./EditListPriceDisable.svg";
import ForceEdit from "./ForceEdit.svg";
import ReturnPopupIcon from "./ReturnPopupIcon.svg";
import DollarCross from "./dollar_tick.svg";
import DollarTick from "./dollar_cross.svg";

const images = {
    bellDoodle,leftPart,personDoodle,
    rightChevronIcon,dahsboardIcon,roundedDoneIcon,greyCloseIcon,dropdownIcon,lockResetIcon,
    manageAccountIcon,notificationIcon,searchIcon,logoutIcon,searchTicketIcon,sidebarTicketIcon,
    sidebarUserIcon,searchUserIcon,passwordHideIcon,passwordUnHideIcon,QuickAsystLogo,sidebarQuickAsystLogo,
    underConstruction,bluetick,publishpopup,GreyFilterIcon,DefaultProfile,Invoice,CloseIcon,
    AddIcon,AffiliateIcon, ReferalIcon, Payout, UserEdit,  Deletepopup, QuickAsystIcon, QuickAsystMailLogo, CopyIcon, QuickAsystWideIcon, TermsandConditions, AutoPayout,errordashboard,barcodeIcon,
     settings,MLB,MLS,NHL,Football,Basketball,EditListPriceDisable,PayoutInprogress,ForceEdit,ReturnPopupIcon, DollarTick, DollarCross

}

export default images;
